import React from 'react'
import styled from 'styled-components'

const EmailAddressSpan = styled.span`
  user-select: all;
`

const ContactSupportMessage: React.FC = () => (
  <React.Fragment>
    Contact <EmailAddressSpan>techsupport@designsforhealth.com</EmailAddressSpan> if you have any
    questions.
  </React.Fragment>
)

export default ContactSupportMessage
